import React, { useMemo, useState } from "react"
import { Row, Col, Card, CardBody, Table, CardTitle } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import moment from "moment"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonTableContainer
          columns={columns}
          data={data}
          // status={true}
      />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
      <Pagi2
            gotoPage={gotoPage}
            previousPage={previousPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ViewFiles = ({customer_files}) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "file_id",
        isInfoIcon: false,
        className:"file_id",
        Cell: cellprops =>{
          return(
            <div className="text-center">
              {cellprops.row.original.id}
            </div>
          )
        }
      },
      {
        Header: "File Name",
        accessor: "file_name",
        isInfoIcon: false,
        className:"file_name",
        Cell: cellprops =>{
          return(
            <div className="text-center">
              {cellprops.row.original.filename || "-"}
            </div>
          )
        }
      },
      {
        Header: "Project Name",
        accessor: "file_project",
        isInfoIcon: false,
        className:"file_project",
        Cell: cellprops =>{
          return(
            <div className="text-center">
              {cellprops.row.original.project_name || "-"}
            </div>
          )
        }
      },
   
      {
        Header: "Created At",
        accessor: "file_created",
        isInfoIcon: false,
        className:"file_created",
        Cell: cellprops =>{
          return(
            <div className="text-center">
               {moment(cellprops.row.original.created_at.slice(0,10)).format("DD-MM-YYYY")}
            </div>
          )
        }
      },
    
      {
        Header: "Action",
        accessor: "file_action",
        isInfoIcon: false,
        className:"file_action",
        Cell : cellprops =>{
          return(
            <a
              href={cellprops?.row?.original?.link}
              target="_blank"
              rel="noreferrer"
             className="btn btn-sm btn-outline-secondary me-1" title="View">
              <i className="fas fa-eye" ></i>
            </a>
          )
        }
      },
    ],
    []
  )

  // const data = [
  //   {
  //     file_id : 1,
  //     file_name:"Proposal.pdf",
  //     file_project: "Earth Development + ZAI",
  //     file_created: "05/12/2024",
  //    },
  //   {
  //     file_id : 2,
  //     file_name:"Contract.pdf",
  //     file_project: "Earth Development + ZAI",
  //     file_created: "05/12/2024",
  //    },
  //   {
  //     file_id : 3,
  //     file_name:"Proposal.pdf",
  //     file_project: "Earth Development + Marketing Module",
  //     file_created: "05/12/2024",
  //    },
  //   {
  //     file_id : 4,
  //     file_name:"Contract.pdf",
  //     file_project: "Earth Development + Marketing Module",
  //     file_created: "05/12/2024",
  //    },
  
  
  
  // ]

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                <CardTitle className="mb-3 text-dark">Files</CardTitle>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={customer_files}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewFiles
